import 'scss/services/leadRobot.scss'
import 'babel-polyfill'
import {
  serviceQA,
  serviceTopbar
} from 'js/libs/utils-services'
import { config } from 'config'
import * as userApi from 'js/api/user'
import { showLoginModal } from 'js/libs/utils-login'
$(function () {
  serviceQA()
  serviceTopbar()
  $('#applyNow').click(function () {
    userApi.checkLogin().then(result => {
      if (result.code === 80000) {
        showLoginModal()
      } else {
        window.open(`${config.CONSOLE}workorder/commit?category=fdc4a3d3ff204d96864c07915ee24f20&tid=ca6536fbf8e84a28bc3071ba747cd04f&categoryName=导诊机器人&tname=商务接洽&title=导诊机器人 - 服务申请&id=leadRobot`)
      }
    })
  })
})



// WEBPACK FOOTER //
// ./src/js/entry/services/leadRobot.js